import { Controller } from '@hotwired/stimulus'

export default class extends Controller<HTMLImageElement> {
  static override values = { placeholder: String }

  declare readonly placeholderValue: string

  override connect() {
    if (this.element.complete && this.element.naturalWidth === 0 && this.element.currentSrc)
      this.fallback()
  }

  fallback() {
    this.element.outerHTML = this.placeholderValue
  }
}
